@if (loading) {
  <div class="properties-view">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

@if (!noMetaData && !loading) {
  <div class="properties-view">
    @for (group of metaDataGroups; track group.group) {
      <table mat-table [dataSource]="group.metaData">
        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef colspan="2">
            <b>{{ group.group }}</b>
          </th>
          <td
            style="max-width: 170px; line-break: anywhere"
            mat-cell
            *matCellDef="let element"
            >
            {{ element.key }}
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <td
            style="max-width: 170px; line-break: anywhere"
            mat-cell
            *matCellDef="let element"
            >
            {{ element.value }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['key']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['key', 'value']"></tr>
      </table>
    }
  </div>
}

@if (noMetaData && !loading) {
  <div class="properties-view properties-view--empty">
    <div class="properties-view__empty-content">
      <div style="margin-bottom: 4px">Asset has no exif data extracted</div>
      <button
        mat-raised-button
        (click)="generateExifData()"
        color="buttonSuccess"
        >
        Extract Exif
      </button>
    </div>
  </div>
}
